import * as Sentry from '@sentry/react';

export const setSentryContext = (
  contextType: string,
  context: {
    [key: string]: any;
  } | null
) => Sentry.setContext(contextType, context);
